import { Flex, Text, Heading } from 'front-end/src/components'
import React, { ReactNode } from 'react'
import { brandColors } from 'shared/basicPalette'
import { FlexProps, HeadingProps } from '@chakra-ui/react'

export const TOPBAR_HEIGHT = '56px'

export const Topbar = ({ children }: { children: ReactNode }) => {
  return (
    <Flex
      borderBottom={`1px solid ${brandColors.grey['100']}`}
      bgColor={brandColors.white}
      position="absolute"
      top={0}
      left={0}
      pl={['8px', '8px', '16px']}
      pr="16px"
      justify="space-between"
      zIndex={4}
      w="100%"
      h={TOPBAR_HEIGHT}
    >
      {children}
    </Flex>
  )
}

export const TopbarLeft = ({
  children,
  ...props
}: FlexProps & { children: ReactNode }) => (
  <Flex
    maxW="50%"
    align="center"
    flex={1}
    position="relative"
    overflow="hidden"
    _after={{
      content: "''",
      position: 'absolute',
      bgGradient: 'linear(to-r, rgba(255,255,255,0), white)',
      w: '24px',
      h: '100%',
      right: 0
    }}
    {...props}
  >
    {children}
  </Flex>
)

export const TopbarCenter = ({
  children,
  ...props
}: FlexProps & { children: ReactNode }) => (
  <Flex align="center" {...props}>
    {children}
  </Flex>
)

export const TopbarRight = ({
  children,
  ...props
}: FlexProps & { children: ReactNode }) => (
  <Flex align="center" justify="flex-end" flex={1} {...props}>
    {children}
  </Flex>
)

export const TopbarTitle = ({
  children,
  ...props
}: HeadingProps & { children: ReactNode }) => (
  <Heading size="md" fontWeight="500" {...props}>
    <Text noOfLines={2}>{children}</Text>
  </Heading>
)
